import { AchieveLink } from 'components/AchieveLink'
import { TypographyNoMui } from 'components/Contentful/TypographyNoMui'

const DirectMailerLinkNoMui = ({ content: mailerContent, track }) => {
  if (!mailerContent?.linkHref) {
    return null
  }
  return (
    <div className={'flex items-center'}>
      <AchieveLink
        className={'text-white hover:underline hover:underline-offset-[2.4px]'}
        href={mailerContent.linkHref}
        track={track}
        underline="hover"
      >
        <TypographyNoMui
          variant="bodySm"
          fontWeight="bold"
          content={mailerContent?.linkText?.json?.content?.[0]?.content?.[0]?.value}
        />
      </AchieveLink>
    </div>
  )
}

export { DirectMailerLinkNoMui }
